module.exports = __webpack_public_path__ + "static/media/6.5'GMN_Screenshots_2.ff297353.png";